/* eslint-disable */
import React, { useCallback, useEffect, useState } from "react";
import {
  Alert, Box, Button, Checkbox, Chip, CircularProgress, Container,
  FormControlLabel, Tab, Tabs, TextField, Typography, Snackbar, LinearProgress, IconButton, InputAdornment,
} from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { useLocation } from "react-router-dom";

const API = "https://api.besteurogirls.com";
const TOKEN_KEY = "beg_model_token";
const RED = "#d4163c";
const getToken = (): string => { try { return window.localStorage.getItem(TOKEN_KEY) || ""; } catch (e) { return ""; } };
const putToken = (t: string) => { try { if (t) window.localStorage.setItem(TOKEN_KEY, t); else window.localStorage.removeItem(TOKEN_KEY); } catch (e) {} };

async function call(path: string, opts: { method?: string; body?: any; form?: FormData } = {}): Promise<any> {
  const headers: any = {};
  const t = getToken();
  if (t) headers.Authorization = "Bearer " + t;
  let body: any = undefined;
  if (opts.form) body = opts.form;
  else if (opts.body !== undefined) { headers["Content-Type"] = "application/json"; body = JSON.stringify(opts.body); }
  const res = await fetch(API + path, { method: opts.method || "GET", headers, body });
  let data: any = {};
  try { data = await res.json(); } catch (e) {}
  if (!res.ok) {
    let msg = (data && data.error && (data.error.message || data.error.type)) || "Something went wrong";
    if (res.status === 401) msg = "Wrong email or password.";
    if (res.status === 429) msg = "Too many attempts. Please try again later.";
    const err: any = new Error(msg); err.status = res.status; err.data = data; throw err;
  }
  return data;
}

async function shrink(file: File, max: number): Promise<Blob> {
  try {
    const bmp: any = await (window as any).createImageBitmap(file, { imageOrientation: "from-image" });
    const k = Math.min(1, max / Math.max(bmp.width, bmp.height));
    const c = document.createElement("canvas");
    c.width = Math.round(bmp.width * k); c.height = Math.round(bmp.height * k);
    c.getContext("2d")!.drawImage(bmp, 0, 0, c.width, c.height);
    const blob: Blob | null = await new Promise((r) => c.toBlob(r, "image/jpeg", 0.9));
    return blob || file;
  } catch (e) { return file; }
}

const htmlToText = (h: string) =>
  String(h || "").replace(/<br\s*\/?>/gi, "\n").replace(/<[^>]*>/g, "").replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&");

const fieldSx = {
  backgroundColor: "transparent !important",
  background: "transparent !important",
  "& .MuiInputBase-root, & .MuiInputBase-root input": { backgroundClip: "padding-box" },
  "& .MuiOutlinedInput-root": {
    color: "#fff", backgroundColor: "#15151a", borderRadius: "12px",
    "& fieldset": { borderColor: "rgba(255,255,255,.18)" },
    "&:hover fieldset": { borderColor: RED }, "&.Mui-focused fieldset": { borderColor: RED },
  },
  "& .MuiInputLabel-root": { color: "rgba(255,255,255,.6)" },
  "& .MuiInputLabel-root.Mui-focused": { color: RED },
  "& input[type=date]": { colorScheme: "dark" },
  "& input:-webkit-autofill, & input:-webkit-autofill:hover, & input:-webkit-autofill:focus": {
    WebkitTextFillColor: "#fff", caretColor: "#fff", WebkitBoxShadow: "0 0 0 100px #2b2e36 inset", transition: "background-color 9999s ease-out 0s",
  },
};
const btnSx = { backgroundColor: RED, fontWeight: 700, borderRadius: "12px", "&:hover": { backgroundColor: "#a8102f" }, "&.Mui-disabled": { backgroundColor: "rgba(212,22,60,.35)", color: "rgba(255,255,255,.65)" } };
const cardSx = { bgcolor: "#15151a", border: "1px solid rgba(255,255,255,.1)", borderRadius: "16px", p: { xs: 2, md: 3 }, mb: 3 };

const SignExample: React.FC = () => {
  const d = new Date();
  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  return (
    <Box sx={{ bgcolor: "#fff", color: "#111", p: 2, borderRadius: 1, textAlign: "center", maxWidth: 260, mx: "auto",
      transform: "rotate(-2deg)", boxShadow: "0 6px 18px rgba(0,0,0,.5)", fontFamily: "'Segoe Print','Comic Sans MS',cursive" }}>
      <Typography sx={{ fontWeight: 800, fontSize: 22, fontFamily: "inherit", color: "#111" }}>BEST EUROGIRLS</Typography>
      <Typography sx={{ fontSize: 24, fontFamily: "inherit", my: 0.5, color: "#111" }}>{dd} / {mm} / {d.getFullYear()}</Typography>
      <Typography sx={{ fontWeight: 800, fontSize: 22, letterSpacing: 3, fontFamily: "inherit", color: "#111" }}>VERIFY</Typography>
    </Box>
  );
};

const AuthScreen: React.FC<{ onDone: () => void }> = ({ onDone }) => {
  const initial = new URLSearchParams(window.location.search).get("mode") === "register" ? 1 : 0;
  const [tab, setTab] = useState(initial);
  const loc = useLocation();
  useEffect(() => { setTab(new URLSearchParams(loc.search).get("mode") === "register" ? 1 : 0); }, [loc.search]);
  const [f, setF] = useState({ email: "", password: "", confirm: "", fullname: "", birthdate: "", terms: false, code: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const set = (k: string) => (e: any) => setF({ ...f, [k]: e.target.value });
  const [showPw, setShowPw] = useState(false);
  const [showCf, setShowCf] = useState(false);
  const [codeSent, setCodeSent] = useState(false);
  const [sendBusy, setSendBusy] = useState(false);
  const [cool, setCool] = useState(0);
  const [codeMsg, setCodeMsg] = useState("");
  useEffect(() => {
    if (cool <= 0) return undefined;
    const t = setTimeout(() => setCool(cool - 1), 1000);
    return () => clearTimeout(t);
  }, [cool]);
  const eye = (on: boolean, toggle: () => void) => ({ endAdornment: (<InputAdornment position="end"><IconButton aria-label="Show or hide password" onClick={toggle} onMouseDown={(e) => e.preventDefault()} edge="end" sx={{ color: "rgba(255,255,255,.7)" }}>{on ? <VisibilityOff /> : <Visibility />}</IconButton></InputAdornment>) });
  const noMatch = f.confirm.length > 0 && f.confirm !== f.password;

  const sendCode = async () => {
    setErr(""); setCodeMsg(""); setSendBusy(true);
    try {
      await call("/public/email-code/send", { method: "POST", body: { email: f.email.trim() } });
      setCodeSent(true); setCool(60); setCodeMsg("Code sent. Check your email (and the spam folder).");
    } catch (ex: any) { setErr(ex.message || "Error"); }
    setSendBusy(false);
  };

  const login = async (email: string, password: string) => {
    const data = await call("/auth/login/user", { method: "POST", body: { email, password } });
    if (!data.token) throw new Error("Login failed");
    putToken(data.token);
    onDone();
  };

  const submit = async (e: React.FormEvent) => {
    e.preventDefault(); setErr(""); setBusy(true);
    try {
      if (tab === 0) { await login(f.email.trim(), f.password); }
      else {
        if (f.password !== f.confirm) throw new Error("Passwords do not match.");
        if (!/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/.test(f.password)) throw new Error("Password: at least 8 characters, with uppercase, lowercase and a number.");
        if (!/^\d{3}-?\d{3}$/.test(f.code.trim())) throw new Error("Enter the 6-digit code we sent to your email.");
        await call("/public/register", { method: "POST", body: { email: f.email.trim(), password: f.password, fullname: f.fullname.trim(), birthdate: f.birthdate, acceptTerms: f.terms, code: f.code.trim() } });
        await login(f.email.trim(), f.password);
      }
    } catch (ex: any) { setErr(ex.message || "Error"); }
    setBusy(false);
  };

  return (
    <Container maxWidth="sm" sx={{ py: 4, color: "#e8e8ec" }}>
      <Typography variant="h4" sx={{ color: "#fff", fontWeight: 700, mb: 1 }}>Advertise with us</Typography>
      <Typography sx={{ mb: 3, color: "rgba(255,255,255,.7)" }}>
        Create your profile, upload your photos and verify your identity. Publishing is free.
      </Typography>
      <Box sx={cardSx}>
        <Tabs value={tab} onChange={(_, v) => { setTab(v); setErr(""); }} textColor="inherit"
          TabIndicatorProps={{ style: { backgroundColor: RED } }} sx={{ mb: 2, color: "#fff" }}>
          <Tab label="Login" /><Tab label="Create account" />
        </Tabs>
        <Box component="form" key={tab} onSubmit={submit} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {tab === 1 && <TextField label="Name / artistic name" required value={f.fullname} sx={fieldSx} inputProps={{ maxLength: 100 }} onChange={set("fullname")} />}
          <TextField label="Email" type="email" required value={f.email} sx={fieldSx} inputProps={{ maxLength: 150, autoComplete: tab === 1 ? "off" : "email" }} onChange={set("email")} />
          {tab === 1 && (
            <Box sx={{ display: "flex", gap: 1, alignItems: "flex-start" }}>
              <TextField label="6-digit code" value={f.code} sx={{ ...fieldSx, flex: 1 }} disabled={!codeSent}
                inputProps={{ maxLength: 7, inputMode: "numeric", autoComplete: "one-time-code" }}
                helperText={codeMsg || (codeSent ? "Check your email (and the spam folder)." : "First send the code to your email.")}
                FormHelperTextProps={{ sx: { color: "rgba(255,255,255,.6)" } }}
                onChange={(e) => setF({ ...f, code: e.target.value })} />
              <Button variant="outlined" disabled={sendBusy || cool > 0 || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(f.email.trim())} onClick={sendCode}
                sx={{ height: 56, whiteSpace: "nowrap", color: "#fff", borderColor: RED, borderRadius: "10px", "&:hover": { borderColor: RED, backgroundColor: "rgba(212,22,60,.12)" }, "&.Mui-disabled": { color: "rgba(255,255,255,.4)", borderColor: "rgba(255,255,255,.2)" } }}>
                {cool > 0 ? "Resend (" + cool + ")" : codeSent ? "Resend code" : "Send code"}
              </Button>
            </Box>
          )}
          {tab === 1 && <TextField label="Date of birth" type="date" required value={f.birthdate} sx={fieldSx} InputLabelProps={{ shrink: true }} onChange={set("birthdate")} />}
          <TextField label="Password" type={showPw ? "text" : "password"} required value={f.password} InputProps={eye(showPw, () => setShowPw(!showPw))} sx={fieldSx} inputProps={{ maxLength: 100, autoComplete: tab === 1 ? "new-password" : "current-password" }} onChange={set("password")} />
          {tab === 1 && <TextField label="Confirm password" type={showCf ? "text" : "password"} required value={f.confirm} InputProps={eye(showCf, () => setShowCf(!showCf))} error={noMatch} helperText={noMatch ? "Passwords do not match." : f.confirm.length > 0 ? "Passwords match." : ""} FormHelperTextProps={{ sx: f.confirm.length > 0 && !noMatch ? { color: "#4caf50" } : {} }} sx={fieldSx} inputProps={{ maxLength: 100, autoComplete: "new-password" }} onChange={set("confirm")} />}
          {tab === 1 && (
            <FormControlLabel sx={{ color: "rgba(255,255,255,.8)" }}
              control={<Checkbox checked={f.terms} onChange={(e) => setF({ ...f, terms: e.target.checked })} sx={{ color: "#fff", "&.Mui-checked": { color: RED } }} />}
              label="I am 18 or older and I agree to advertise under my own name and with my own photos." />
          )}
          {err && <Alert severity="error">{err}</Alert>}
          <Button type="submit" variant="contained" size="large" disabled={busy || (tab === 1 && !f.terms)} sx={btnSx}>
            {busy ? "Please wait..." : tab === 0 ? "Login" : "Create account"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

const Dashboard: React.FC<{ onLogout: () => void }> = ({ onLogout }) => {
  const [me, setMe] = useState<any>(null);
  const [images, setImages] = useState<any[]>([]);
  const [form, setForm] = useState({ fullname: "", shortDescription: "", richDescription: "" });
  const [note, setNote] = useState<{ type: "success" | "error" | "info"; text: string } | null>(null);
  const [sec, setSec] = useState("profile");
  const [busy, setBusy] = useState("");

  const applyMe = (m: any) => {
    setMe(m);
    setForm({ fullname: m.fullname || "", shortDescription: m.shortDescription || "", richDescription: htmlToText(m.richDescription) });
  };

  const load = useCallback(async () => {
    try {
      const a = await call("/me"); applyMe(a.me);
      const b = await call("/me/images"); setImages(b.images || []);
    } catch (ex: any) {
      if (ex.status === 401 || ex.status === 403) { putToken(""); onLogout(); }
      else setNote({ type: "error", text: ex.message });
    }
  }, [onLogout]);
  useEffect(() => { load(); }, [load]);

  const guard = async (label: string, fn: () => Promise<void>) => {
    setBusy(label); setNote(null);
    try { await fn(); } catch (ex: any) { setNote({ type: "error", text: ex.message }); }
    setBusy("");
  };

  const saveProfile = () => guard("save", async () => {
    const a = await call("/me", { method: "PUT", body: form });
    applyMe(a.me); setNote({ type: "success", text: "Saved." });
  });

  const upload = (files: FileList | null) => guard("photos", async () => {
    if (!files) return;
    for (const file of Array.from(files)) {
      const blob = await shrink(file, 1800);
      const fd = new FormData(); fd.append("image", blob, "photo.jpg");
      const r = await call("/me/images", { method: "POST", form: fd }); setImages(r.images || []);
    }
    setNote({ type: "success", text: "Photos uploaded." });
  });

  const makeMain = (id: number) => guard("main", async () => { const r = await call("/me/images/" + id + "/main", { method: "POST", body: {} }); setImages(r.images || []); });
  const remove = (id: number) => { if (!window.confirm("Delete this photo?")) return; guard("del", async () => { const r = await call("/me/images/" + id, { method: "DELETE" }); setImages(r.images || []); }); };

  const uploadVerification = (files: FileList | null) => guard("verif", async () => {
    if (!files || !files[0]) return;
    const blob = await shrink(files[0], 2000);
    const fd = new FormData(); fd.append("photo", blob, "verification.jpg");
    const r = await call("/me/verification", { method: "POST", form: fd });
    applyMe(r.me); setNote({ type: "success", text: "Verification photo uploaded." });
  });

  const submitReview = () => guard("submit", async () => {
    await call("/me", { method: "PUT", body: form });
    const pr = await call("/me/profile");
    const need: string[] = [];
    if (!pr.phone) need.push("phone");
    if (!pr.countryId) need.push("country");
    if (!pr.cityId) need.push("city");
    if (need.length) throw new Error("Please add: " + need.join(", ") + " (section 2) and press Save.");
    try { const r = await call("/me/submit", { method: "POST", body: {} }); applyMe(r.me); setNote({ type: "success", text: "Sent for review. We will approve your profile soon." }); }
    catch (ex: any) {
      const miss = ex.data && ex.data.error && ex.data.error.missing;
      throw new Error(miss ? "Please add: " + miss.join(", ") + "." : ex.message);
    }
  });

  if (!me) return <Box sx={{ py: 8, textAlign: "center" }}><CircularProgress sx={{ color: RED }} /></Box>;

  const live = me.status === "active";
  const submitted = me.status === "pending" && !!me.submittedAt;
  const verifiedOk = !!me.verified;
  const topActive = me.membership === "TOP" && (!me.topUntil || new Date(me.topUntil) > new Date());
  const act = me.status === "active" || me.status === "hidden";
  const sh = (k: string) => (sec === k ? {} : { display: "none" as const });
  const okProfile = !!(form.fullname.trim() && form.richDescription.trim());
  const okPhotos = images.length > 0;
  const okVerif = verifiedOk || me.verificationStatus === "submitted";
  const missing: string[] = [];
  if (!okProfile) missing.push("profile");
  if (!okPhotos) missing.push("photos");
  if (!okVerif) missing.push("verification");
  const pct = Math.round(((3 - missing.length) / 3) * 100);
  const mk = (ok: boolean) => <span style={{ marginLeft: 6, fontWeight: 700, color: ok ? "#4caf50" : "#ffb300" }}>{ok ? "\u2713" : "\u25CF"}</span>;

  return (
    <Container maxWidth="md" sx={{ py: 4, color: "#e8e8ec" }}>
      <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 1, mb: 2 }}>
        <Typography variant="h4" sx={{ color: "#fff", fontWeight: 700 }}>My account</Typography>
        <Button onClick={() => { putToken(""); onLogout(); }} sx={{ color: "#fff" }}>Logout</Button>
      </Box>

      {live && <Alert severity="success" sx={{ mb: 2 }}>Your profile is live on the website.{topActive && me.topUntil ? " TOP until " + new Date(me.topUntil).toLocaleDateString() + "." : ""}</Alert>}
      {submitted && <Alert severity="info" sx={{ mb: 2 }}>Your profile is under review. We will contact you if we need anything else.</Alert>}
      {me.status === "rejected" && <Alert severity="warning" sx={{ mb: 2 }}>Your profile was not approved: {me.rejectionReason || "please review your information"}. Fix it and send it again.</Alert>}
      {me.status === "pending" && !me.submittedAt && <Alert severity="info" sx={{ mb: 2 }}>Complete your profile and press "Send for review" at the end.</Alert>}
      {pct < 100 && (
        <Box sx={{ mb: 2 }}>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,.75)", mb: 0.75 }}>Your ad is {pct}% complete. Missing: {missing.join(", ")}.</Typography>
          <LinearProgress variant="determinate" value={pct} sx={{ height: 6, borderRadius: 3, bgcolor: "rgba(255,255,255,.12)", "& .MuiLinearProgress-bar": { bgcolor: RED } }} />
        </Box>
      )}
      <Tabs value={sec} onChange={(_e, v) => setSec(v)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile textColor="inherit"
        TabIndicatorProps={{ style: { backgroundColor: RED } }}
        sx={{ mb: 2, borderBottom: "1px solid rgba(255,255,255,.15)", color: "#fff", "& .MuiTab-root": { textTransform: "none", fontWeight: 600, color: "rgba(255,255,255,.65)" }, "& .Mui-selected": { color: "#fff !important" }, "& .MuiTabScrollButton-root": { color: "#fff" } }}>
        <Tab value="profile" label={<span>Profile{mk(okProfile)}</span>} />
        <Tab value="services" label="Services & rates" />
        <Tab value="photos" label={<span>Photos{mk(okPhotos)}</span>} />
        <Tab value="verif" label={<span>Verification{mk(okVerif)}</span>} />
        {act && <Tab value="video" label="Video" />}
        {act && <Tab value="ad" label="My ad" />}
        {(live || me.status !== "hidden") && <Tab value="review" label={live ? "Top position" : "Send for review"} />}
      </Tabs>

      <Box sx={{ ...cardSx, ...sh("profile") }}>
        <Typography variant="h6" sx={{ color: "#fff", mb: 2 }}>1. Your profile</Typography>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField label="Name" value={form.fullname} sx={fieldSx} inputProps={{ maxLength: 100 }} onChange={(e) => setForm({ ...form, fullname: e.target.value })} />
          <TextField label="Short headline (max 100 characters)" value={form.shortDescription} sx={fieldSx} inputProps={{ maxLength: 100 }} onChange={(e) => setForm({ ...form, shortDescription: e.target.value })} />
          <TextField label="About me" multiline minRows={6} value={form.richDescription} sx={fieldSx} inputProps={{ maxLength: 6000 }} onChange={(e) => setForm({ ...form, richDescription: e.target.value })} />
          <Button variant="contained" onClick={saveProfile} disabled={!!busy} sx={{ ...btnSx, alignSelf: "flex-start" }}>{busy === "save" ? "Saving..." : "Save"}</Button>
        </Box>
      </Box>

      <Box sx={sh("services")}><ProfileExtra /></Box>

      <Box sx={{ ...cardSx, ...sh("photos") }}>
        <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>3. Your photos</Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>Only photos of you. Clear, well lit, no other people. Up to 12. The first photo marked as main is shown on the home page.</Typography>
        <Box sx={{ display: "grid", gridTemplateColumns: { xs: "repeat(2,1fr)", sm: "repeat(4,1fr)" }, gap: 1.5, mb: 2 }}>
          {images.map((im) => (
            <Box key={im.id} sx={{ position: "relative", borderRadius: 1, overflow: "hidden", border: im.isMain ? "2px solid " + RED : "1px solid rgba(255,255,255,.15)" }}>
              <Box component="img" src={im.thumbnailUrl} alt="" sx={{ width: "100%", aspectRatio: "2/3", objectFit: "cover", display: "block" }} />
              {im.isMain && <Chip label="MAIN" size="small" sx={{ position: "absolute", top: 6, left: 6, bgcolor: RED, color: "#fff", fontWeight: 700 }} />}
              <Box sx={{ display: "flex", justifyContent: "space-between", p: 0.5, bgcolor: "rgba(0,0,0,.7)" }}>
                {!im.isMain ? <Button size="small" sx={{ color: "#fff", minWidth: 0 }} onClick={() => makeMain(im.id)}>Main</Button> : <span />}
                <Button size="small" sx={{ color: "#ff8a8a", minWidth: 0 }} onClick={() => remove(im.id)}>Delete</Button>
              </Box>
            </Box>
          ))}
        </Box>
        <Button variant="outlined" component="label" disabled={!!busy || images.length >= 12} sx={{ color: "#fff", borderColor: "rgba(255,255,255,.4)" }}>
          {busy === "photos" ? "Uploading..." : "Add photos"}
          <input hidden type="file" accept="image/jpeg,image/png,image/webp" multiple onChange={(e) => { upload(e.target.files); e.target.value = ""; }} />
        </Button>
      </Box>

      <Box sx={{ ...cardSx, ...sh("verif") }}>
        <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>4. Verification photo</Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>
          To avoid fake profiles, take a photo of yourself holding a paper sign like this one, written <b>by hand, with today's date</b>. Your face and the sign must be clearly visible. This photo is private: only our team sees it and it is never published.
        </Typography>
        <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 3, alignItems: "center" }}>
          <Box sx={{ flex: 1, width: "100%" }}><SignExample /></Box>
          <Box sx={{ flex: 1, width: "100%" }}>
            {verifiedOk && <Alert severity="success" sx={{ mb: 2 }}>You are verified.</Alert>}
            {!verifiedOk && me.verificationStatus === "submitted" && <Alert severity="info" sx={{ mb: 2 }}>Photo received on {new Date(me.verificationUploadedAt).toLocaleString()}. We will check it soon.</Alert>}
            {!verifiedOk && me.verificationStatus === "none" && <Alert severity="warning" sx={{ mb: 2 }}>Not verified yet. Unverified profiles are shown with a "not verified" label.</Alert>}
            <Button variant="outlined" component="label" disabled={!!busy} sx={{ color: "#fff", borderColor: "rgba(255,255,255,.4)" }}>
              {busy === "verif" ? "Uploading..." : me.verificationStatus === "none" ? "Upload verification photo" : "Replace verification photo"}
              <input hidden type="file" accept="image/jpeg,image/png,image/webp" onChange={(e) => { uploadVerification(e.target.files); e.target.value = ""; }} />
            </Button>
          </Box>
        </Box>
      </Box>

      {act && <Box sx={sh("ad")}><VisitsBox /><AdControls onChange={load} /></Box>}
      {act && <Box sx={sh("video")}><VideoBox /></Box>}
      {live && <Box sx={sh("review")}><PayTop topActive={topActive} vipActive={me.membership === "VIP" && (!me.topUntil || new Date(me.topUntil).getTime() > Date.now())} topUntil={me.topUntil || null} onPaid={load} /></Box>}
      {!live && me.status !== "hidden" && (
        <Box sx={{ ...cardSx, ...sh("review") }}>
          <Typography variant="h6" sx={{ color: "#fff", mb: 1 }}>5. Send for review</Typography>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>You need at least one photo. Verification is recommended: verified profiles get a verified badge.</Typography>
          <Button variant="contained" size="large" onClick={submitReview} disabled={!!busy} sx={btnSx}>
            {busy === "submit" ? "Sending..." : submitted ? "Send again" : "Send for review"}
          </Button>
        </Box>
      )}
    <Snackbar open={!!note} autoHideDuration={4500} onClose={(_e, r) => { if (r !== "clickaway") setNote(null); }} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
        <Alert severity={note ? note.type : "success"} variant="filled" onClose={() => setNote(null)} sx={{ width: "100%" }}>{note ? note.text : ""}</Alert>
      </Snackbar>
    </Container>
  );
};

/* ---- QR encoder (byte mode, ECC M, versions 1-9) ---- */
const QR_ECC = [0, 10, 16, 26, 18, 24, 16, 18, 22, 22];
const QR_BLOCKS = [0, 1, 1, 1, 2, 2, 4, 4, 4, 5];
const qrRaw = (v: number) => {
  let r = (16 * v + 128) * v + 64;
  if (v >= 2) { const n = Math.floor(v / 7) + 2; r -= (25 * n - 10) * n - 55; if (v >= 7) r -= 36; }
  return r;
};
const qrData = (v: number) => Math.floor(qrRaw(v) / 8) - QR_ECC[v] * QR_BLOCKS[v];
const gfMul = (x: number, y: number) => {
  let z = 0;
  for (let i = 7; i >= 0; i--) { z = (z << 1) ^ ((z >>> 7) * 0x11d); z ^= ((y >>> i) & 1) * x; }
  return z;
};
const rsDiv = (deg: number) => {
  const r: number[] = new Array(deg).fill(0); r[deg - 1] = 1;
  let root = 1;
  for (let i = 0; i < deg; i++) {
    for (let j = 0; j < r.length; j++) { r[j] = gfMul(r[j], root); if (j + 1 < r.length) r[j] ^= r[j + 1]; }
    root = gfMul(root, 2);
  }
  return r;
};
const rsRem = (data: number[], div: number[]) => {
  const r: number[] = div.map(() => 0);
  for (const b of data) {
    const f = b ^ (r.shift() as number);
    r.push(0);
    div.forEach((c, i) => { r[i] ^= gfMul(c, f); });
  }
  return r;
};
const qrMatrix = (text: string): boolean[][] => {
  const bytes: number[] = [];
  const u = unescape(encodeURIComponent(text));
  for (let i = 0; i < u.length; i++) bytes.push(u.charCodeAt(i));
  let ver = 1;
  while (ver <= 9 && 12 + bytes.length * 8 > qrData(ver) * 8) ver++;
  if (ver > 9) throw new Error("QR text too long");
  const bits: number[] = [];
  const put = (val: number, len: number) => { for (let i = len - 1; i >= 0; i--) bits.push((val >>> i) & 1); };
  put(4, 4); put(bytes.length, 8); bytes.forEach((b) => put(b, 8));
  const cap = qrData(ver) * 8;
  put(0, Math.min(4, cap - bits.length));
  while (bits.length % 8) bits.push(0);
  for (let pad = 0xec; bits.length < cap; pad ^= 0xec ^ 0x11) put(pad, 8);
  const data: number[] = [];
  for (let i = 0; i < bits.length; i += 8) { let b = 0; for (let j = 0; j < 8; j++) b = (b << 1) | bits[i + j]; data.push(b); }
  const nb = QR_BLOCKS[ver], el = QR_ECC[ver], raw = Math.floor(qrRaw(ver) / 8);
  const nShort = nb - (raw % nb), sLen = Math.floor(raw / nb);
  const div = rsDiv(el);
  const blocks: number[][] = [];
  for (let i = 0, k = 0; i < nb; i++) {
    const dl = sLen - el + (i < nShort ? 0 : 1);
    const dat = data.slice(k, k + dl); k += dl;
    const ecc = rsRem(dat, div);
    if (i < nShort) dat.push(0);
    blocks.push(dat.concat(ecc));
  }
  const all: number[] = [];
  for (let i = 0; i < blocks[0].length; i++) blocks.forEach((b, j) => { if (i !== sLen - el || j >= nShort) all.push(b[i]); });

  const size = ver * 4 + 17;
  const m: boolean[][] = []; const fn: boolean[][] = [];
  for (let i = 0; i < size; i++) { m.push(new Array(size).fill(false)); fn.push(new Array(size).fill(false)); }
  const setF = (x: number, y: number, d: boolean) => { m[y][x] = d; fn[y][x] = true; };
  const bit = (x: number, i: number) => ((x >>> i) & 1) !== 0;
  for (let i = 0; i < size; i++) { setF(6, i, i % 2 === 0); setF(i, 6, i % 2 === 0); }
  const finder = (x: number, y: number) => {
    for (let dy = -4; dy <= 4; dy++) for (let dx = -4; dx <= 4; dx++) {
      const d = Math.max(Math.abs(dx), Math.abs(dy)), xx = x + dx, yy = y + dy;
      if (xx >= 0 && xx < size && yy >= 0 && yy < size) setF(xx, yy, d !== 2 && d !== 4);
    }
  };
  finder(3, 3); finder(size - 4, 3); finder(3, size - 4);
  const na = ver === 1 ? 0 : Math.floor(ver / 7) + 2;
  const pos: number[] = [];
  if (na) {
    const step = Math.ceil((ver * 4 + 4) / (na * 2 - 2)) * 2;
    pos.push(6);
    for (let p = size - 7, c = na - 1; c > 0; c--, p -= step) pos.splice(1, 0, p);
  }
  for (let i = 0; i < pos.length; i++) for (let j = 0; j < pos.length; j++) {
    if ((i === 0 && j === 0) || (i === 0 && j === pos.length - 1) || (i === pos.length - 1 && j === 0)) continue;
    for (let dy = -2; dy <= 2; dy++) for (let dx = -2; dx <= 2; dx++) setF(pos[i] + dx, pos[j] + dy, Math.max(Math.abs(dx), Math.abs(dy)) !== 1);
  }
  const fmt = (mask: number) => {
    const d = (0 << 3) | mask; let r = d;
    for (let i = 0; i < 10; i++) r = (r << 1) ^ ((r >>> 9) * 0x537);
    const b = ((d << 10) | r) ^ 0x5412;
    for (let i = 0; i <= 5; i++) setF(8, i, bit(b, i));
    setF(8, 7, bit(b, 6)); setF(8, 8, bit(b, 7)); setF(7, 8, bit(b, 8));
    for (let i = 9; i < 15; i++) setF(14 - i, 8, bit(b, i));
    for (let i = 0; i < 8; i++) setF(size - 1 - i, 8, bit(b, i));
    for (let i = 8; i < 15; i++) setF(8, size - 15 + i, bit(b, i));
    setF(8, size - 8, true);
  };
  fmt(0);
  if (ver >= 7) {
    let r = ver;
    for (let i = 0; i < 12; i++) r = (r << 1) ^ ((r >>> 11) * 0x1f25);
    const b = (ver << 12) | r;
    for (let i = 0; i < 18; i++) { const a = size - 11 + (i % 3), c = Math.floor(i / 3); setF(a, c, bit(b, i)); setF(c, a, bit(b, i)); }
  }
  let k = 0;
  for (let right = size - 1; right >= 1; right -= 2) {
    if (right === 6) right = 5;
    for (let vert = 0; vert < size; vert++) for (let j = 0; j < 2; j++) {
      const x = right - j, up = ((right + 1) & 2) === 0, y = up ? size - 1 - vert : vert;
      if (!fn[y][x] && k < all.length * 8) { m[y][x] = bit(all[k >>> 3], 7 - (k & 7)); k++; }
    }
  }
  const apply = (mask: number) => {
    for (let y = 0; y < size; y++) for (let x = 0; x < size; x++) {
      let inv = false;
      switch (mask) {
        case 0: inv = (x + y) % 2 === 0; break;
        case 1: inv = y % 2 === 0; break;
        case 2: inv = x % 3 === 0; break;
        case 3: inv = (x + y) % 3 === 0; break;
        case 4: inv = (Math.floor(x / 3) + Math.floor(y / 2)) % 2 === 0; break;
        case 5: inv = ((x * y) % 2) + ((x * y) % 3) === 0; break;
        case 6: inv = (((x * y) % 2) + ((x * y) % 3)) % 2 === 0; break;
        default: inv = (((x + y) % 2) + ((x * y) % 3)) % 2 === 0;
      }
      if (!fn[y][x] && inv) m[y][x] = !m[y][x];
    }
  };
  const penalty = () => {
    let p = 0;
    for (let y = 0; y < size; y++) {
      let run = 1, runc = 1;
      for (let x = 1; x < size; x++) {
        run = m[y][x] === m[y][x - 1] ? run + 1 : 1; if (run === 5) p += 3; else if (run > 5) p++;
        runc = m[x][y] === m[x - 1][y] ? runc + 1 : 1; if (runc === 5) p += 3; else if (runc > 5) p++;
      }
    }
    for (let y = 0; y < size - 1; y++) for (let x = 0; x < size - 1; x++) if (m[y][x] === m[y][x + 1] && m[y][x] === m[y + 1][x] && m[y][x] === m[y + 1][x + 1]) p += 3;
    return p;
  };
  let best = 0, bestP = Infinity;
  for (let mask = 0; mask < 8; mask++) {
    fmt(mask); apply(mask);
    const p = penalty();
    if (p < bestP) { bestP = p; best = mask; }
    apply(mask);
  }
  fmt(best); apply(best);
  return m;
};

const QrSvg: React.FC<{ text: string; size?: number }> = ({ text, size = 168 }) => {
  const m = React.useMemo(() => { try { return qrMatrix(text); } catch (e) { return null; } }, [text]);
  if (!m) return null;
  const n = m.length, q = 3;
  let d = "";
  m.forEach((row, y) => row.forEach((on, x) => { if (on) d += "M" + (x + q) + " " + (y + q) + "h1v1h-1z"; }));
  return (
    <svg width={size} height={size} viewBox={"0 0 " + (n + q * 2) + " " + (n + q * 2)} shapeRendering="crispEdges" role="img" aria-label="QR code of the payment address" style={{ background: "#fff", borderRadius: 12, display: "block" }}>
      <path d={d} fill="#000" />
    </svg>
  );
};

const PayTop: React.FC<{ topActive: boolean; vipActive?: boolean; topUntil: string | null; onPaid: () => void }> = ({ topActive, vipActive, topUntil, onPaid }) => {
  const [info, setInfo] = useState<any>(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const [tick, setTick] = useState(0);
  const [copied, setCopied] = useState("");
  const prev = React.useRef(0);

  const load = useCallback(async () => {
    try {
      const r = await call("/me/pay/top");
      if (prev.current && !r.order) {
        const o = (r.recent || []).find((x: any) => x.id === prev.current);
        if (o && o.status === "paid") onPaid();
      }
      prev.current = r.order ? r.order.id : 0;
      setInfo(r);
    } catch (ex: any) { setErr(ex.message); }
  }, [onPaid]);
  useEffect(() => { load(); }, [load]);

  const pendingId = info && info.order ? info.order.id : 0;
  useEffect(() => {
    if (!pendingId) return;
    const t = setInterval(() => setTick((x) => x + 1), 1000);
    return () => clearInterval(t);
  }, [pendingId]);
  useEffect(() => { if (pendingId && tick > 0 && tick % 10 === 0) load(); }, [tick, pendingId, load]);

  const start = async (plan: string) => {
    setBusy(plan); setErr("");
    try { await call("/me/pay/" + plan.toLowerCase(), { method: "POST", body: {} }); await load(); }
    catch (ex: any) { setErr(ex.message); }
    setBusy("");
  };
  const copy = async (k: string, v: string) => {
    try { await navigator.clipboard.writeText(v); setCopied(k); setTimeout(() => setCopied(""), 1500); } catch (e) { /* ignore */ }
  };

  if (!info) return null;
  const order = info.order;
  const plans = info.plans || { TOP: { price: info.price, days: info.days }, VIP: null };
  const left = order ? Math.max(0, Math.floor((order.expiresAt - Date.now()) / 1000)) : 0;
  const mm = String(Math.floor(left / 60)).padStart(2, "0");
  const ss = String(left % 60).padStart(2, "0");
  const mono = { fontFamily: "monospace", fontSize: 15, wordBreak: "break-all" as const, color: "#fff" };
  const until = topUntil ? new Date(topUntil).toLocaleDateString() : "";
  const planBox = (code: string, title: string, text: string) => {
    const p = plans[code];
    if (!p) return null;
    return (
      <Box sx={{ flex: 1, minWidth: 220, border: "1px solid rgba(255,255,255,.15)", borderRadius: "14px", p: 2, display: "flex", flexDirection: "column", gap: 1 }}>
        <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>{title}</Typography>
        <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", flex: 1 }}>{text}</Typography>
        <Typography sx={{ color: "#fff", fontWeight: 700 }}>{p.price} USDT · {p.days} days</Typography>
        <Button variant="contained" onClick={() => start(code)} disabled={!!busy} sx={btnSx}>
          {busy === code ? "Please wait..." : "Pay " + p.price + " USDT"}
        </Button>
      </Box>
    );
  };

  return (
    <Box sx={cardSx}>
      <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>Get a top position</Typography>
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>
        Paid profiles appear above all free profiles. When the period ends, your profile goes back to the free list.
        {vipActive && until ? " Your VIP is active until " + until + "." : topActive && until ? " Your TOP is active until " + until + "." : ""}
      </Typography>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      {!info.wallet && <Alert severity="info">Online payments will be available very soon.</Alert>}
      {info.wallet && !order && (
        <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 2 }}>
          {planBox("TOP", "TOP", "Above all free profiles, rotating on every visit." + (topActive && until ? " Paying again adds more days." : ""))}
          {planBox("VIP", "VIP", "The very first positions, above TOP and free profiles." + (vipActive && until ? " Paying again adds more days." : ""))}
        </Box>
      )}
      {info.wallet && order && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography sx={{ color: "#fff", fontWeight: 700 }}>{order.plan || "TOP"} plan</Typography>
          <Box sx={{ display: "flex", flexDirection: { xs: "column", sm: "row" }, gap: 3, alignItems: { xs: "center", sm: "flex-start" } }}>
            <QrSvg text={info.wallet} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, minWidth: 0 }}>
          <Box>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)" }}>Send exactly (USDT)</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
              <Typography sx={{ ...mono, fontSize: 28, fontWeight: 700 }}>{order.amount}</Typography>
              <Button size="small" onClick={() => copy("a", order.amount)} sx={{ color: "#fff" }}>{copied === "a" ? "Copied" : "Copy"}</Button>
            </Box>
          </Box>
          <Box>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)" }}>To this address — network TRON (TRC20). The QR contains the address only; type the exact amount.</Typography>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>
              <Typography sx={mono}>{info.wallet}</Typography>
              <Button size="small" onClick={() => copy("w", info.wallet)} sx={{ color: "#fff" }}>{copied === "w" ? "Copied" : "Copy"}</Button>
            </Box>
          </Box>
            </Box>
          </Box>
          <Alert severity="warning">
            Use the <b>TRON (TRC20)</b> network only. The amount that arrives must be exactly <b>{order.amount} USDT</b>: if your exchange or wallet deducts a network fee, add it on top. Other networks or amounts cannot be matched automatically.
          </Alert>
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,.7)" }}>
            {left > 0 ? "This payment request expires in " + mm + ":" + ss + ". " : "This request expired. "}
            Your {order.plan || "TOP"} is activated automatically a few minutes after the transaction is confirmed. You can close this page.
          </Typography>
        </Box>
      )}
    </Box>
  );
};
const RATE_LAYOUT = [
  { key: "incall", title: "Incall (at your place)", rows: [["m15", "15 min"], ["m30", "30 min"], ["m45", "45 min"], ["h1", "1 hour"], ["h2", "2 hours"], ["overnight", "Overnight"]] },
  { key: "outcall", title: "Outcall (at the client's place)", rows: [["h1", "1 hour"], ["h2", "2 hours"], ["overnight", "Overnight"]] },
];

const ProfileExtra: React.FC = () => {
  const [cat, setCat] = useState<any>(null);
  const [p, setP] = useState<any>(null);
  const [msg, setMsg] = useState<{ type: "success" | "error"; text: string } | null>(null);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const c = await call("/me/profile/catalog");
        const d = await call("/me/profile");
        setCat(c); setP(d);
      } catch (ex: any) { setMsg({ type: "error", text: ex.message }); }
    })();
  }, []);

  if (!cat || !p) return msg ? <Box sx={cardSx}><Alert severity="error">{msg.text}</Alert></Box> : null;

  const country = (cat.countries || []).find((c: any) => c.id === p.countryId);
  const cities = country ? country.cities : [];
  const svc = (id: number) => (p.services || []).find((s: any) => s.serviceOfferedId === id);
  const setSvc = (id: number, change: any) => setP({ ...p, services: (p.services || []).map((s: any) => (s.serviceOfferedId === id ? { ...s, ...change } : s)) });
  const toggleSvc = (id: number) => {
    if (svc(id)) setP({ ...p, services: p.services.filter((s: any) => s.serviceOfferedId !== id) });
    else setP({ ...p, services: [...(p.services || []), { serviceOfferedId: id, included: true, extraCharge: "" }] });
  };
  const nativeSx = { ...fieldSx, "& option": { color: "#000" } };

  const save = async () => {
    setBusy(true); setMsg(null);
    try {
      const r = await call("/me/profile", { method: "PUT", body: { phone: p.phone, countryId: p.countryId, cityId: p.cityId, rates: p.rates, services: p.services } });
      setP(r); setMsg({ type: "success", text: "Saved." });
    } catch (ex: any) { setMsg({ type: "error", text: ex.message }); }
    setBusy(false);
  };

  return (
    <Box sx={cardSx}>
      <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>2. Contact, services and rates</Typography>
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>
        Your phone is shown on your profile so clients can contact you. Leave a rate empty to show "ask".
      </Typography>
      <Snackbar open={!!msg} autoHideDuration={4500} onClose={(_e, r) => { if (r !== "clickaway") setMsg(null); }} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}><Alert severity={msg ? msg.type : "success"} variant="filled" onClose={() => setMsg(null)} sx={{ width: "100%" }}>{msg ? msg.text : ""}</Alert></Snackbar>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr 1fr" }, gap: 2, mb: 3 }}>
        <TextField label="Phone / WhatsApp (with country code)" value={p.phone} sx={fieldSx} inputProps={{ maxLength: 40 }} onChange={(e) => setP({ ...p, phone: e.target.value })} />
        <TextField select SelectProps={{ native: true }} label="Country" value={p.countryId || ""} sx={nativeSx} InputLabelProps={{ shrink: true }}
          onChange={(e) => setP({ ...p, countryId: Number(e.target.value) || null, cityId: null })}>
          <option value="">Select...</option>
          {(cat.countries || []).map((c: any) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </TextField>
        <TextField select SelectProps={{ native: true }} label="City" value={p.cityId || ""} sx={nativeSx} InputLabelProps={{ shrink: true }} disabled={!country}
          onChange={(e) => setP({ ...p, cityId: Number(e.target.value) || null })}>
          <option value="">{country ? "Select..." : "Choose a country first"}</option>
          {cities.map((c: any) => <option key={c.id} value={c.id}>{c.name}</option>)}
        </TextField>
      </Box>

      {RATE_LAYOUT.map((g) => (
        <Box key={g.key} sx={{ mb: 2 }}>
          <Typography sx={{ color: "#fff", fontWeight: 600, mb: 1 }}>{g.title}</Typography>
          <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr 1fr", sm: "repeat(3,1fr)" }, gap: 1.5 }}>
            {g.rows.map((r) => (
              <TextField key={g.key + r[0]} label={r[1]} placeholder="ask" value={(p.rates[g.key] && p.rates[g.key][r[0]]) || ""} sx={fieldSx} inputProps={{ maxLength: 20 }}
                onChange={(e) => setP({ ...p, rates: { ...p.rates, [g.key]: { ...p.rates[g.key], [r[0]]: e.target.value } } })} />
            ))}
          </Box>
        </Box>
      ))}

      <Typography sx={{ color: "#fff", fontWeight: 600, mt: 3, mb: 1 }}>Services you offer</Typography>
      <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" }, gap: 0.5 }}>
        {(cat.services || []).map((s: any) => {
          const cur = svc(s.id);
          return (
            <Box key={s.id} sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 1 }}>
              <FormControlLabel sx={{ color: "#fff", minWidth: 190, m: 0 }} label={s.name}
                control={<Checkbox checked={!!cur} onChange={() => toggleSvc(s.id)} sx={{ color: "rgba(255,255,255,.5)" }} />} />
              {cur && (
                <>
                  <TextField select SelectProps={{ native: true }} size="small" value={cur.included ? "included" : "extra"} sx={{ ...nativeSx, width: 110 }}
                    onChange={(e) => setSvc(s.id, { included: e.target.value === "included" })}>
                    <option value="included">Included</option>
                    <option value="extra">Extra</option>
                  </TextField>
                  {!cur.included && (
                    <TextField size="small" placeholder="Price" value={cur.extraCharge} sx={{ ...fieldSx, width: 90 }} inputProps={{ inputMode: "decimal", maxLength: 8 }}
                      onChange={(e) => setSvc(s.id, { extraCharge: e.target.value.replace(/[^0-9.]/g, "") })} />
                  )}
                </>
              )}
            </Box>
          );
        })}
      </Box>

      <Button variant="contained" onClick={save} disabled={busy} sx={{ ...btnSx, mt: 3 }}>{busy ? "Saving..." : "Save contact, services and rates"}</Button>
    </Box>
  );
};
const VisitsBox: React.FC = () => {
  const [s, setS] = useState<any>(null);
  useEffect(() => {
    (async () => { try { setS(await call("/me/stats")); } catch (e) { /* ignore */ } })();
  }, []);
  if (!s) return null;
  return (
    <Box sx={cardSx}>
      <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>Visits</Typography>
      <Typography sx={{ color: "#fff", fontSize: 40, fontWeight: 700, lineHeight: 1.1 }}>{Number(s.total || 0).toLocaleString()}</Typography>
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,.7)", mt: 0.5 }}>
        Times your profile has been opened. Last 7 days: <b>{Number(s.last7 || 0).toLocaleString()}</b> · Last 30 days: <b>{Number(s.last30 || 0).toLocaleString()}</b>
      </Typography>
    </Box>
  );
};
const AdControls: React.FC<{ onChange: () => void }> = ({ onChange }) => {
  const [ad, setAd] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = useCallback(async () => {
    try { setAd(await call("/me/ad")); } catch (ex: any) { setErr(ex.message); }
  }, []);
  useEffect(() => { load(); }, [load]);
  const act = async (what: "pause" | "resume") => {
    if (what === "pause" && !window.confirm("Your ad will stop being shown on the website until you activate it again. Continue?")) return;
    setBusy(true); setErr("");
    try { await call("/me/ad/" + what, { method: "POST", body: {} }); await load(); onChange(); }
    catch (ex: any) { setErr(ex.message); }
    setBusy(false);
  };
  if (!ad) return null;
  const on = ad.status === "active";
  return (
    <Box sx={cardSx}>
      <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>Your ad</Typography>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      {on && (
        <>
          <Alert severity="success" sx={{ mb: 2 }}>Your ad is ACTIVE and visible on the website.</Alert>
          <Button variant="outlined" disabled={busy} onClick={() => act("pause")} sx={{ color: "#fff", borderColor: "rgba(255,255,255,.4)", borderRadius: "12px" }}>
            {busy ? "Please wait..." : "Deactivate my ad"}
          </Button>
        </>
      )}
      {!on && ad.paused && (
        <>
          <Alert severity="warning" sx={{ mb: 2 }}>Your ad is DEACTIVATED: it is not shown on the website.</Alert>
          <Button variant="contained" disabled={busy} onClick={() => act("resume")} sx={btnSx}>
            {busy ? "Please wait..." : "Activate my ad"}
          </Button>
        </>
      )}
      {!on && !ad.paused && <Alert severity="warning">Your ad was deactivated by our team and is not shown on the website. Please contact us.</Alert>}
    </Box>
  );
};

const VideoBox: React.FC = () => {
  const [video, setVideo] = useState<any>(null);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ok, setOk] = useState("");
  const load = useCallback(async () => {
    try { const r = await call("/me/video"); setVideo(r.video || null); } catch (ex: any) { setErr(ex.message); }
  }, []);
  useEffect(() => { load(); }, [load]);

  const duration = (file: File) => new Promise<number>((resolve) => {
    const el = document.createElement("video");
    const url = URL.createObjectURL(file);
    el.preload = "metadata";
    el.onloadedmetadata = () => { URL.revokeObjectURL(url); resolve(el.duration); };
    el.onerror = () => { URL.revokeObjectURL(url); resolve(-1); };
    el.src = url;
  });

  const pick = async (files: FileList | null) => {
    const f = files && files[0];
    if (!f) return;
    setErr(""); setOk("");
    if (!/^video\/(mp4|webm|quicktime)$/.test(f.type)) { setErr("Use an MP4, MOV or WebM video."); return; }
    if (f.size > 20 * 1024 * 1024) { setErr("The video must be smaller than 20 MB."); return; }
    const d = await duration(f);
    if (d < 0) { setErr("We could not read this video. Try an MP4 file."); return; }
    if (d > 15.5) { setErr("Your video is " + d.toFixed(1) + " seconds long. The maximum is 15 seconds."); return; }
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("video", f);
      const r = await call("/me/video", { method: "POST", form: fd });
      setVideo(r.video || null);
      setOk("Video uploaded. It will appear on your profile after our team approves it.");
    } catch (ex: any) { setErr(ex.message); }
    setBusy(false);
  };

  const remove = async () => {
    if (!window.confirm("Delete your video?")) return;
    setBusy(true); setErr(""); setOk("");
    try { await call("/me/video", { method: "DELETE" }); setVideo(null); } catch (ex: any) { setErr(ex.message); }
    setBusy(false);
  };

  return (
    <Box sx={cardSx}>
      <Typography variant="h6" sx={{ color: "#fff", mb: 0.5 }}>Your video</Typography>
      <Typography variant="body2" sx={{ color: "rgba(255,255,255,.6)", mb: 2 }}>
        One video, up to 15 seconds and 20 MB (MP4, MOV or WebM). It is shown below your photos once approved. On iPhone, use Settings &gt; Camera &gt; Formats &gt; Most Compatible so it plays everywhere.
      </Typography>
      {err && <Alert severity="error" sx={{ mb: 2 }}>{err}</Alert>}
      {ok && <Alert severity="success" sx={{ mb: 2 }}>{ok}</Alert>}
      {video && (
        <Box sx={{ mb: 2 }}>
          <video src={video.url} controls playsInline preload="metadata" style={{ width: "100%", maxWidth: 360, borderRadius: 12, background: "#000" }} />
          <Typography variant="body2" sx={{ color: video.approved ? "#3fb950" : "#d29922", mt: 1 }}>
            {video.approved ? "Approved and visible on your profile." : "Waiting for approval."}
          </Typography>
        </Box>
      )}
      <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
        <Button variant="outlined" component="label" disabled={busy} sx={{ color: "#fff", borderColor: "rgba(255,255,255,.4)", borderRadius: "12px" }}>
          {busy ? "Please wait..." : video ? "Replace video" : "Upload video"}
          <input hidden type="file" accept="video/mp4,video/quicktime,video/webm" onChange={(e) => { pick(e.target.files); e.target.value = ""; }} />
        </Button>
        {video && <Button disabled={busy} onClick={remove} sx={{ color: "#ff8a8a" }}>Delete video</Button>}
      </Box>
    </Box>
  );
};

export const Account: React.FC = () => {
  const [logged, setLogged] = useState(!!getToken());
  return logged ? <Dashboard onLogout={() => setLogged(false)} /> : <AuthScreen onDone={() => setLogged(true)} />;
};
